/*
  The small toast at the bottom of the screen.

  Two kinds, because it was only ever one: every message came up green
  with a tick, including "Nothing was uploaded". A failure announced with
  a success mark reads as the opposite of itself, and the customer has to
  finish the sentence before they learn which it was.

  `variant` is "success" by default, so every existing caller keeps the
  behaviour it had.
*/
export const floatMessage = (text, variant = "success") => {
  const floatMessageDiv = document.createElement("div");
  floatMessageDiv.className =
    variant === "error" ? "float_message float_message_error" : "float_message";

  /*
    Announced to assistive technology as well as drawn. An alert is
    interrupting by nature; a confirmation is not, so it is only read when
    the reader next pauses.
  */
  floatMessageDiv.setAttribute("role", variant === "error" ? "alert" : "status");

  const span = document.createElement("span");
  span.textContent = text;
  floatMessageDiv.appendChild(span);
  document.body.appendChild(floatMessageDiv);

  /*
    An error is usually longer than a confirmation and is the one worth
    reading, so it is given longer before it goes.
  */
  setTimeout(
    () => {
      floatMessageDiv.remove();
    },
    variant === "error" ? 6000 : 3000
  );
};
